import removeDiacritics from './removeDiacritics';
import unescape from './unescape';

const normalizeTrackerLabel = (str: string | null | undefined = null) => {
  if (typeof str === 'string') {
    const strCleaned = removeDiacritics(unescape(str));
    if (typeof strCleaned === 'string') {
      return strCleaned
        .toLowerCase()
        .replace(/[' -]/g, '_')
        .replace(/[.]/g, '');
    }
  }

  return '';
};

export default normalizeTrackerLabel;
